import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { envAwarePost, capitalize } from '../../util/util'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Spinner from 'react-bootstrap/Spinner'
import Form from "react-bootstrap/Form"
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker"
import { selectTrainerParam } from '../users/usersSlice'
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import { 
    toggleWeekdayAvailabilities,
    getAllEventsInRange,
    editCalendarDate,
    deleteCalendarEvent,
    registerForGroupSession,
    unregisterFromGroupSession
} from "../../state/schedulerSlice"
import { getAllClients } from '../users/usersSlice.js'
import ScheduleModal from "./ScheduleModal"
import Event from "./Event"
import Event24Hour from "./Event24Hour"
import classes from "./Scheduler.module.css"
import "./styles.css"
import { dateToTimeObj, dateToYMD,getTimeString } from '../../util/datetime'
import { useSwipeable } from 'react-swipeable';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import CopyModal from '../EventList/CopyModal/CopyModal'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import ReadableRepeat from './ReadableRepeat'
import AvailabilityModal from './AvailabilityModal'
import {useSessions} from '../FinancialsDashboard/hooks'
import ConfirmButton from '../ConfirmButton/ConfirmButton'
import useCurrentUser from '../../hooks/useCurrentUser'
import {
    updateCopy,
    addEventForCopying,
    getEventDetails
} from '../../state/events'
import { 
    createLink, 
    determineClient, 
    determineDeletePermissions, 
    mapToDays,
    makeGoogleCalendarUrl,
    makeOutlookCalendarUrl,
    makeICSCalendarUrl
} from './utilities'


const DragAndDropCalendar = withDragAndDrop(Calendar)

const EventCalendar = () => {

    const [selectedDate, setSelectedDate] = useState('')

    // workouts/tasks/nutrition = external events
    const [externalEventModalShow, setExternalEventModalShow] = useState(false)
    const [externalEventNotes, setExternalEventNotes] = useState("");
    const [externalEventRecurring, setExternalEventRecurring] = useState(false)

    const [isEventDetailsLoading, setIsEventDetailsLoading] = useState(false)


    const [modalToggle, setModalToggle] = useState(false) // this is so if client clicks on same event, modal will still show

    const [isEventsLoading, setIsEventsLoading] = useState(false)
    const [eventDetails, setEventDetails] = useState({})
    const [calendarDate, setCalendarDate] = useState(null)
    const [isEventBeingMoved, setIsEventBeingMoved] = useState(false)

    const [moreModalShow, setMoreModalShow] = useState(false)
    const [moreModalDate, setMoreModalDate] = useState('')
    const [moreModalEvents, setMoreModalEvents] = useState([])

    const [showScheduleModal, setShowScheduleModal] = useState(false)
    const [showOptionsModal, setShowOptionsModal] = useState(false)

    const [scheduleEventData, setScheduleEventData] = useState({});
    const [editData, setEditData] = useState("")
    const [editSeries, setEditSeries] = useState(false)
    const [currentView, setCurrentView] = useState("week");
    const localizer = momentLocalizer(moment)
    const [isDeleting, setIsDeleting] = useState(false);
    const [startOfMonth, setStartOfMonth] = useState('')

    const params = new URLSearchParams(window.location.search)
    const calendarId = params.get('calendarId')

    const dispatch = useDispatch();

    const isTrainer = useSelector(state => state.users.current_user.account_type) === 'trainer'
    const isGym = useSelector(state => state.users.current_user.account_type) === 'gym'
    const isTrainerOrGym = isTrainer || isGym;

    const trainerParam = useSelector(selectTrainerParam)

    const currentUser = useSelector(state => state.users.current_user)

    const isClient = useSelector(state => state.users.current_user.account_type) === 'client'

    const isTime24Hour = Number(useSelector(state => state.users.current_user.is_24_hour_time))

    let timeformatString = Boolean(isTime24Hour) ? "HH:mm" : "h:mmA";
    //gets clientlist from store then converts to array and sorts by name
    const allClients = useSelector(state => state.users.clients.entities)

    const [urlEventDisplayed, setUrlEventDisplayed] = useState(false);


    const statusDispatch = useApiStatusDispatch();

    //always ensure a fresh list of clients when opening schedule modal
    useEffect(()=>{
        if (showScheduleModal) dispatch(getAllClients())
    },[showScheduleModal])


    //add swipe capability for scheduler on mobile
    const handlers = useSwipeable({
        onSwiped: (eventData) => {
            if (eventData.dir === "Left") {
                advanceOrSubtractFromDate(calendarDate, currentView, "add")
            } else if (eventData.dir == "Right") {
                advanceOrSubtractFromDate(calendarDate, currentView, "subtract")
            }
        }
    });

    function advanceOrSubtractFromDate(calendarDate, view, direction) {

        if (direction == "add") {
            // figure out what nextDate is
            let nextDate = moment(calendarDate).add(1, view);

            //set selectedDate to start of month of nextDate
            setSelectedDate(startMonthDate(nextDate.toDate()));

            //advance calendar date to nextDate 
            setCalendarDate(nextDate.toDate())
        } else if (direction == "subtract") {
            // figure out what nextDate is
            let nextDate = moment(calendarDate).subtract(1, view);

            //set selectedDate to start of month of nextDate
            setSelectedDate(startMonthDate(nextDate.toDate()));

            //go backwards from calendar date to nextDate
            setCalendarDate(nextDate.toDate())
        }
    }


    function handleExternalEvent(e) {
        setIsEventDetailsLoading(true);

        handleAddEventForCopying(e)
        setExternalEventModalShow(true)

        let payload = {
            event_type:e.event_type,
            event_id:e.event_id 
        };

        dispatch(getEventDetails(payload))
        .then(res=>{
            setIsEventDetailsLoading(false);
            if (res.payload.success === "1"){
                const {data} = res.payload;
                setExternalEventNotes(data.notes)
                setExternalEventRecurring(Boolean(data.recurring))
            }
        })
        
    }


    // formats event data for the calendar component
    const formatEventList = (data) => {
        let formattedEvents = []
        let date;
        data.forEach(events => {
            date = events.date
            events?.events?.forEach(event => {
                let seriesStartDate = null;
                let seriesEndDate = null;
                //get all clients for this event
                const clients = (
                    (allClients && event.client_ids) ?
                        event?.client_ids.split(',').map(client_id => allClients[client_id]).filter(c => c) :
                        []
                )
                if (event.recurrence_type?.length) {
                    seriesStartDate = moment(event.start_date).toDate();
                    seriesEndDate = moment(event.end_date).toDate();
                }
                const formattedEvent = {
                    ...event,
                    title: event.text,
                    start: moment(date + " " + event.start_time).toDate(),
                    end: moment(date + " " + event.end_time).toDate(),
                    // allDay: true,
                    no_end_date: event.no_end_date,
                    seriesStartDate,
                    seriesEndDate,
                    resource: null,
                    client_ids: event.client_ids,
                    event_type: event.event_type,
                    id: event.calendar_id,
                    event_id: event.event_id,
                    body: event.body,
                    repeat_frequency: event.repeat_frequency,
                    recurrence_type: event.recurrence_type,
                    week_days: event.week_days,
                    status: event.status,
                    reminder_time: event.reminder_time,
                    send_pushnote: event.send_pushnote,
                    send_email: event.send_email,
                    clients
                }

                formattedEvents.push(formattedEvent)
            })
        })
        return formattedEvents.filter((event)=>{
            return (
                currentUser.account_type !== 'trainer'
                || event.event_type !== 'personal'
                || event.trainers.map(t=>t.user_id_number).includes(parseInt(currentUser.user_id_number))
            )
        })
    }

    const formattedEventList = useSelector(state => formatEventList(state.scheduler.eventData));
    const eventList = useSelector(state => state.scheduler.eventData);


    function convertDate(date) {
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        const yyyy = date.getFullYear();
        if (dd < 10) { dd = `0${dd}`; }
        if (mm < 10) { mm = `0${mm}`; }
        date = `${yyyy}-${mm}-${dd}`;
        return date;
    }

    const urlParams = new URLSearchParams(window.location.search)
    let mobileStatus = urlParams.get('mobile')

    if (mobileStatus == "1") {
        mobileStatus = true;
    } else {
        mobileStatus = false;
    }

    let urlStartDate = urlParams.get('startDate');
    let urlEventId = Number(urlParams.get('id'));

    function parseUrlStartDate(urlStartDate){
        let [yyyy, mm, dd] = urlStartDate.split("-");
        return {yyyy, mm, dd}
    }

    function parseNewDate(today){
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        const yyyy = today.getFullYear();
        if (dd < 10) { dd = `0${dd}`; }
        if (mm < 10) { mm = `0${mm}`; }
        return {yyyy, mm, dd}

    }

    //gets todays date then sets selectedDate 
    useEffect(() => {
        let today;


        // check if urlParam exists and make sure not to give dirty date
        let {yyyy, mm, dd} = (urlStartDate) && moment(urlStartDate).toDate() !== "Invalid Date" ? 
                                parseUrlStartDate(urlStartDate) :
                                parseNewDate(new Date()) 


        today = `${yyyy}-${mm}-${dd}`;
    
        setCalendarDate(moment(today).toDate())
        setStartOfMonth(`${yyyy}-${mm}-01`)
        setSelectedDate(today)
    }, [urlStartDate])


    const filterFormattedList = (list, urlEventId) =>{
        return list.filter(item=>{
            return item.id === urlEventId;
        })
    }

    useEffect(()=>{
        let event;
        if (formattedEventList.length && urlEventId && !urlEventDisplayed){
            event = filterFormattedList(formattedEventList, urlEventId);

            if (event.length){
                // store that url has been displayed
                setUrlEventDisplayed(true)

                // take first item from filtered list 
                event = event[0];
                setEditData(event);
                
                if (event.event_id&&['workout','task','nutrition'].includes(event.event_type)) {
                    handleAddEventForCopying(event)
                    setExternalEventModalShow(true)
                } else {
                    // regular calendar event (not workout/task/nutrition)
                    setShowOptionsModal(true)
                }
            }
        }
    },[urlEventId, eventList,urlEventDisplayed])

    //load in events then set eventlist
    useEffect(() => {
        if (selectedDate) {
            setIsEventsLoading(true)
            getEvents(selectedDate);

        }
    }, [selectedDate])



    // get all events in in same month as date provided 
    function getEvents (sDate) {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
        //get selected month
        const startMonth = startMonthDate(moment(sDate).toDate())
        //get 7 days into previous month
        const startDateObj = moment(startMonth).toDate()
        startDateObj.setDate(startDateObj.getDate() - 7)

        let payload = {
            action: "getAllEventsInRange",
            start_date: dateToYMD(startDateObj),
            offset: 0,
            //get at least 7 days into next month
            //7 to account for -1
            //31 to get all events in current month
            //7 to get 7 days into next month
            //7 + 31 + 7 = 45
            limit: 45,
            tz,

        }
        dispatch(getAllEventsInRange(payload))
            .then(() => {
                setIsEventsLoading(false)
            })
    }

    useEffect(() => {
        if (isTrainerOrGym) {
            dispatch(getAllClients())
        }
    }, [])

    //color codes the calendar event nodes depending on type
    let colorArray = ['rgb(177 255 105)', 'rgb(255 178 123)', '#B6F0EE', '#fc9898', '#9ef0a8 ']

    const eventStyleGetter = (event, start, end, isSelected, isShowMore) => {
        let color;
        switch (event.event_type) {
            case 'workout':
                color = '#B6F0EE'
                break
            case 'nutrition':
                color = 'rgb(255 194 119)'
                break
            case 'task':
                color = 'rgb(177 255 105)'
                break
            case 'not_available':
                color = 'grey'
                break
            case "personal":
                color = '#e0e0e0'
                break
            case "group_session":
                color = "#b8a6f7"
                break
            case "meeting":
                color = '#ffeccf'
                break
            case "closed":
                color = '#6e6e6e'
                break
            case "notes":
                color= "#fdfdfd"
                break
            case "semi_private":
                color = '#03a9fc'
                break
            default:
                color = '#9ef0a8'
        }

        if (event.status == "2") {
            color = "#f0a89e"
        }
        // if its a requested appointment 
        color = event.status == "0" ? 'rgb(249 230 160)' : color;

        let style = {
            backgroundColor: color,
        }
        if (isShowMore) {
            return color
        } else {
            return {
                style: style,
            }
        }

    }

    // return start of month of date provided (e.g 9/12/2020 -> 9/01/2020)
    function startMonthDate(date) {
        let mm = date.getMonth() + 1;
        const yyyy = date.getFullYear();
        if (mm < 10) { mm = `0${mm}`; }
        date = `${yyyy}-${mm}-01`;
        return date;
    }

    //for calendar, updates the date on toolbar click
    const handleNavigation = (date, view, navButton) => {

        if (navButton === "PREV" || navButton === "NEXT") {
            setSelectedDate(startMonthDate(date))
            setCalendarDate(moment(date).toDate())
        } else if (navButton === 'TODAY') {
            setSelectedDate(convertDate(date))
            setCalendarDate(moment(date).toDate())
        }
    }

    let months = {
        'Jan': '01',
        'Feb': '02',
        'Mar': '03',
        'Apr': '04',
        'May': '05',
        'Jun': '06',
        'Jul': '07',
        'Aug': '08',
        'Sep': '09',
        'Oct': '10',
        'Nov': '11',
        'Dec': '12'
    }

    const moveEvent = ({ event, start, end }) => {

        if (event.event_type == "not_available") {
            return;
        }

        let eventStart = (start.toString()).split(" ")
        let eventEnd = (end.toString()).split(" ");
        let eventStartDate = `${eventStart[3]}-${months[eventStart[1]]}-${eventStart[2]}`
        let eventStartFullDate = `${eventStart[3]}-${months[eventStart[1]]}-${eventStart[2]} ${eventStart[4]}`
        let eventEndFullDate = `${eventEnd[3]}-${months[eventEnd[1]]}-${eventEnd[2]} ${eventEnd[4]}`
        let payload = {
            action: 'editCalendarDate',
            start_date: eventStartFullDate,
            end_date: eventEndFullDate,
            event_id: event.id,
            old_start_date: moment(event.start).format("YYYY-MM-DD HH:mm:ss"),
            status: event.status
        }

        setIsEventBeingMoved(true);
        dispatch(editCalendarDate(payload))
            .then(() => {
                getEvents(selectedDate);
            })
            .then((res) => {
                setIsEventBeingMoved(false);
            })

        if (event.event_id) {
            let eventPayload = {
                action: 'updateEvent',
                event_type: event.event_type,
                date: eventStartDate,
                event_id: (event.event_id).toString()
            }
            envAwarePost('/api/events/api/', eventPayload)

        }
    }

    const eventTypeToPrintSelector = type => (
        ['workout', 'task'].includes(type) ? `${capitalize(type)}s` : capitalize(type)
    )

    const handleShowMore = (e) => {
        setMoreModalShow(true)
        setMoreModalEvents(e)
        let date = (moment(e[0].start)).toString().split(' ').splice(0, 3).join(' ')
        setMoreModalDate(date)
    }

    const determineClientNames = () => (
        editData.clients.map(user => user.user_name).join(", ")
    )

    function generateTitleInfo(editData) {

        if (isTrainerOrGym) {
            return editData.status == "0" ? `(Requested by ${determineClient(allClients, editData.client_ids)})` : null
        } else {
            if (editData.status == "0") {
                return "(pending response)"
            } else if (editData.status == "2") {
                return "(declined by trainer)"
            } else {
                return "(accepted)"
            }
        }
    }

    function handlePrint() {
        let sideNav = document.querySelector(".App_SideContent__Rs8PF")
        sideNav.style.display = "none";
        window.print();
        sideNav.style.display = "initial";
    }

    function handleAddEventForCopying(e) {
        let type = e.event_type;
        type = type + "_id";
        let payload = { ...e };
        payload[type] = e.event_id;
        payload.note = "";
        payload.published = 0;
        payload.start = moment(e.start).format("YYYY-MM-DD HH:mm:ss");
        payload.end = moment(e.end).format("YYYY-MM-DD HH:mm:ss");
        dispatch(addEventForCopying(payload))
    }

    function handleDeleteEvent(isSeries) {
        let payload = {
            edit_series: isSeries ? "1" : "0",
            action: "deleteCalendarEvent",
            event_type: editData.event_type,
            event_id: editData.id,
            old_start_date: moment(editData.start).format("YYYY-MM-DD HH:mm:ss")
        }


        setIsDeleting(isSeries ? "series" : "event");
        statusDispatch(deleteCalendarEvent(payload), "event", "delete")
            .then(() => {
                getEvents(selectedDate);
                setShowOptionsModal(false);
                setEditData("");
                setIsDeleting(false);
            })

    }

    const [recurringRegistration,setRecurringRegistration] = useState(false)

    const [registerStatus,setRegisterStatus] = useState('idle')
    const {totalAvailableCredits:totalAvailableSessionCredits} = useSessions()

    const handleRegisterForGroupSession = ()=>{
        if(
            editData.consume_session_credit &&
            !window.confirm('Are you sure you want to use a session credit to register for this class?')
        ) return
        setRegisterStatus('pending')
        statusDispatch(registerForGroupSession({
            group_session_id:editData.event_id,
            date:editData.occurrence_date,
            is_recurring:Number(recurringRegistration),
            is_semi_private:Number(editData.event_type==='semi_private')
        }),'class','register').then(()=>{
            setRegisterStatus('idle')
            getEvents(editData.occurrence_date)
            setShowOptionsModal(false)
        })
    }

    const handleUnregisterForGroupSession = ()=>{
        if(!window.confirm('Are you sure you want to unregister for this class?')) return 
        setRegisterStatus('pending')
        statusDispatch(unregisterFromGroupSession({
            'group_session_id':editData.event_id,
            'date':editData.occurrence_date,
            unregister_from_all:Number(recurringRegistration),
            is_semi_private:Number(editData.event_type==='semi_private')
        }),'class','unregister').then(()=>{
            setShowOptionsModal(false)
            setRegisterStatus('idle')
            getEvents(editData.occurrence_date)
        })
    }


    function handleCreateLink(type) {
        if(!editData) return ''
        const start = {
            date : editData.seriesStartDate ? editData.seriesStartDate : editData.start,
            time : getTimeString(dateToTimeObj(editData.start, isTime24Hour),isTime24Hour)
        }

        const noEnd = parseInt(editData.no_end_date) === 1
        const end = {
            date :  (
                noEnd
                ? start.date
                : (editData.seriesEndDate ? editData.seriesEndDate : editData.end)
            ),
            time : getTimeString(dateToTimeObj(editData.end, isTime24Hour),isTime24Hour),
            noEnd : editData.no_end_date === "1" ? true : false
        }

        const calendarEvent = {
            name: editData.text,
            location: '',
            details: editData.body,
            startsAt: `${dateToYMD(start.date)}T${start.time}`,
            endsAt: `${dateToYMD(end.date)}T${end.time}`,
        }

        const repeatType = editData.recurrence_type
        if(Boolean(repeatType)){
            const interval = editData?.repeat_frequency
            const repeatWeekDays = mapToDays(editData.week_days)

        

            if (repeatType === 'day') {
                calendarEvent.rrule = `RRULE:FREQ=DAILY;INTERVAL=${interval}`
            } else if (repeatType == "week") {
                const standardizedWeekDay = repeatWeekDays.map(item => (item.slice(0, 2)))
                const byDay = standardizedWeekDay.join(",").toUpperCase();
                calendarEvent.rrule = `RRULE:FREQ=WEEKLY;INTERVAL=${interval};WKST=MO;BYDAY=${byDay}`
            }
        }

        if(type==='google'){
            return makeGoogleCalendarUrl(calendarEvent)
        }
        if(type==='ics'){
            return makeICSCalendarUrl(calendarEvent)
        }
        if(type==='outlook'){
            return makeOutlookCalendarUrl(calendarEvent)
        }
    }

    const user = useCurrentUser()
    const isGroupSession = editData.event_type === 'group_session' || editData.event_type === 'semi_private'
    const isParticipant = editData.client_ids?.includes(user.user_id_number)

    const hoursUntilDate = (dateString)=>{
        // Parsing the input date string
        const futureDate = new Date(
            dateString.split(' ').join('T')
        );

        const now = new Date();

        // Calculating the difference in time (in milliseconds)
        const differenceInMilliseconds = futureDate.getTime() - now.getTime();

        // Converting the difference to hours
        const differenceInHours = differenceInMilliseconds / 1000 / 60 / 60;

        // Return the difference
        return differenceInHours;
    }

    const allowSignupCancel = ()=>(
        editData && (
            parseInt(editData.signup_cancel_buffer) === 0
            || !editData.signup_cancel_buffer
            || hoursUntilDate(`${editData.occurrence_date} ${editData.start_time}`) > parseInt(editData.signup_cancel_buffer)
        )
    )

    const eventTypeText = (()=>{
        if (!editData) return ''
        const customTypes = ['semi_private','group_session']
        if(customTypes.includes(editData.event_type)){
            switch(editData.event_type){
                case 'semi_private': return 'Semi-private training session'
                case 'group_session': return 'Class'
            }
        }
        else {
            return editData.event_type
        }
    })()


    return (
        <div {...handlers} style={{ height: "100%" }}>
            <div>
                <div className="pt-2 px-2 px-md-3">
                    {mobileStatus && <div className="pl-3 mt-3">
                        <i className="fa fa-info-circle"> </i> <i> To create a new event, press and hold desired calendar date. </i>
                    </div>}
                    <div className="w-100">
                        <div className="hiddenPrint" >
                            <p className='p-form-label'>Search Date:</p>

                            <DatePicker
                                selected={calendarDate}
                                onChange={(date) => { setSelectedDate(startMonthDate(date)); setCalendarDate(moment(date).toDate()) }}
                                dateFormat="EEE, MMM d, yyyy"
                            />
                            {isEventBeingMoved && <Spinner animation="border" variant="primary" />}

                        </div>
                    </div>

                    <div >

                        <div className="d-flex justify-content-between ">
                            <div style={{ fontSize: "12.8px" }} className="">
                                <i className="fas fa-circle mr-1" style={{ color: 'rgb(103 209 206)' }}>
                                </i>Workouts | <i className="fas fa-circle mr-1" style={{ color: 'rgb(173 247 0)' }}>
                                </i>Tasks | <i className="fas fa-circle mr-1" style={{ color: 'rgb(255 156 33)' }}>
                                </i>Nutrition | <i className="fas fa-circle mr-1" style={{ color: 'rgb(178, 158, 247)' }}>
                                </i> Class | <i className="fas fa-circle mr-1" style={{ color: '#ffeccf' }}>
                                </i> Meeting | <i className="fas fa-circle mr-1" style={{ color: '#03a9fc' }}>
                                </i> Semi-private

                                <div style={{ fontSize: "12.8px" }} className="mt-2">
                                    <i className="fas fa-circle mr-1" style={{ color: 'rgb(0 207 25)' }}>
                                    </i>Accepted Event | <i className="fas fa-circle mr-1" style={{ color: 'rgb(224, 224, 224)' }}>
                                    </i>Personal Event | <i className="fas fa-circle mr-1" style={{ color: 'rgb(251, 221, 115)' }}>
                                    </i>Requested Event {isClient && <span> | <i className="fas fa-circle mr-1" style={{ color: '#f0a89e' }} ></i>Declined Event  </span>}
                                </div>
                            </div>
                            <div>
                                {!isClient&&
                                    <OverlayTrigger overlay={
                                        <Tooltip>Set the hours you have available each week</Tooltip>
                                    }>
                                        <Button 
                                            onClick={()=>{
                                                dispatch(toggleWeekdayAvailabilities(true))
                                            }}
                                            variant="outline-primary" 
                                            className="mr-2"
                                        >
                                            <i className="fas fa-calendar-week"/> My Availability
                                        </Button>
                                    </OverlayTrigger>
                                }
                                {currentView != "month" && <Button
                                    onClick={handlePrint}
                                    className="align-self-center hiddenPrint"
                                >
                                    Print
                                </Button>}
                            </div>
                        </div>
                    </div>
                </div>
                <>
                    {isEventsLoading && <div className="isEventsLoadingSpinner" > <Spinner style={{ zIndex: "1000" }} animation="border" variant="primary" /> </div>}

                    <DragAndDropCalendar
                        components={{ 
                            //need to pass component as a function
                            //so that we can access isTime24Hour variable
                            event: (props)=>(
                                <Event 
                                    is24HourTime={Boolean(isTime24Hour)}
                                    {...props}
                                />
                            )
                        }}
                        formats={{
                            //the custom event component handles displaying the times
                            //so return empty string for time
                            eventTimeRangeFormat: () => { return '' }
                        }}
                        popup

                        selectable="ignoreEvents"
                        events={formattedEventList}
                        startAccessor="start"
                        endAccessor="end"
                        onEventDrop={moveEvent}
                        onNavigate={handleNavigation}
                        onShowMore={handleShowMore}
                        eventPropGetter={eventStyleGetter}
                        onSelectSlot={({ action, start, end }) => {
                            setShowScheduleModal(true)
                            setScheduleEventData({ action, start, end })
                        }}

                        onSelectEvent={ e => {
                            if (e.event_type !== "not_available") {
                                setEditData(e);
                                // workout/task/nutriton have event_id
                                if (e.event_id&&['workout','task','nutrition'].includes(e.event_type)) {
                                    handleExternalEvent(e)
                                } else {
                                    setShowOptionsModal(true)
                                }
                            }
                        }}

                        // defaults
                        defaultView={"week"}
                        onView={(view) => setCurrentView(view)}
                        date={calendarDate}
                        localizer={localizer}
                        style={{ width: 'auto', zIndex: -1000, marginBottom: '30px', marginRight: '0px' }}
                        views={["month", "week", "day", "agenda"]}
                        formats={{
                            timeGutterFormat:(date)=>{
                                const timeObj = dateToTimeObj(date)
                                return `${timeObj.hour}${timeObj.p}`
                            },
                            eventTimeRangeFormat: () => ""
                        }}
                        draggableAccessor={
                            event => event.event_type !== 'semi_private' || user.account_type!=='client'
                        }
                    />
                </>

                {/* ********* MODALS BELOW *************/}

                <ScheduleModal
                    showScheduleModal={showScheduleModal}
                    setShowScheduleModal={setShowScheduleModal}
                    scheduleEventData={scheduleEventData}
                    setScheduleEventData={setScheduleEventData}
                    editData={editData}
                    setEditData={setEditData}
                    editSeries={editSeries}
                    setEditSeries={setEditSeries}
                    getEvents={() => getEvents(selectedDate)}
                    currentView={currentView}
                />


                {/* WORKOUT/TASK/NUTRITION Modal*/}
                <Modal
                    show={externalEventModalShow}
                    className='event-info-modal myCalendarCloseButton'
                    onHide={() => { setExternalEventModalShow(false); setEditData("") }}
                    style={{ display: 'flex !important', flexDirection: 'column', alignItems: 'center' }}
                >
                    <Modal.Title className="text-center mt-2 mx-2">
                        <i> {editData.title}</i>
                        <div>
                            <span className="" style={{ fontWeight: "normal", fontSize: "1.1rem" }}>
                                {moment(editData.start).format(timeformatString)} - {moment(editData.end).format(timeformatString)}
                            </span>
                        </div>
                        {externalEventRecurring && 
                            <div>
                                <small style={{fontSize:".9rem"}}> Part of a recurring series</small>
                            </div>}

                    </Modal.Title>
                    <hr style={{ width: '100%', margin: '0px' }} />
                    {isEventDetailsLoading ? <Spinner animation="border" variant="primary" /> :
                     externalEventNotes.length ? 
                        <Modal.Body style={{ width: '100%' }}>
                            <p style={{ whiteSpace: 'pre-wrap' }}>{externalEventNotes}</p>
                        </Modal.Body> : null}
                    <Modal.Footer>
                        {/* don't display these  */}
                        {isEventDetailsLoading ? null :
                            //on mobile don't allow the edit/view buttons 
                            mobileStatus ?
                                `To view this event's details go to the ${editData.event_type} tab.` :
                                <div >
                                    {(isTrainerOrGym) &&
                                        <Button
                                            style={{ "fontSize": "14px", "marginRight": "3px", }}
                                            onClick={(e) => {
                                                setExternalEventModalShow(false);
                                                dispatch(updateCopy({
                                                    show: true,
                                                    type: editData.event_type,
                                                    id: editData.event_id
                                                }))
                                                e.currentTarget.blur();
                                            }}
                                            variant="outline-primary"
                                        >
                                            Copy Event
                                        </Button>
                                    }

                                    {isTrainerOrGym &&
                                        <Button
                                            style={{ "fontSize": "14px", "margin": "0px" }}
                                            as={Link}
                                            to={`/eventEditor/?event_id=${editData.event_id}&event_type=AddOrEdit&eventType=${capitalize(editData.event_type)}&client=${editData.client_ids}&origin=myCalendar&${trainerParam}`}
                                            variant="outline-primary"
                                        >
                                            Edit Event
                                        </Button>
                                    }
                                    <Button
                                        style={{ "fontSize": "14px", "marginLeft": "3px" }}
                                        as={Link}
                                        to={`/eventsView?display=${editData.event_id}&selector=${eventTypeToPrintSelector(editData.event_type)}&filter=client&client=${editData.client_ids}&origin=myCalendar&view=list${trainerParam}`}
                                    >
                                        View details
                                    </Button>

                                </div>
                        }
                    </Modal.Footer>
                </Modal>

                <CopyModal />

                {/* show multiple day events simultaneously modal */}
                <Modal
                    show={moreModalShow}
                    className='event-info-modal myCalendarCloseButton'
                    onHide={() => setMoreModalShow(false)}
                    style={{ display: 'flex !important', flexDirection: 'column', alignItems: 'center' }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title style={{ padding: "10px" }}>Events on {moreModalDate}: </Modal.Title>
                    </Modal.Header>
                    <hr style={{ width: '100%', margin: '0px' }} />
                    <Modal.Body style={{ width: '100%' }}>
                        <Row>
                            <Col className='button-column'>
                                {moreModalEvents.map((event) => {
                                    let isShowMore = true
                                    let color = eventStyleGetter(event, null, null, null, isShowMore)

                                    return (
                                        <div className="moreModalShowEventStyle" style={{
                                            backgroundColor: color,
                                            //borderBottom: "1px solid grey",
                                        }} onClick={() => {
                                            if (event.event_type == "not_available") {
                                                return;
                                            }
                                            setEditData(event)
                                            setModalToggle(!modalToggle)
                                            setMoreModalShow(false)

                                            if (event.event_id) {
                                                setExternalEventModalShow(true)
                                            } else {
                                                setShowOptionsModal(true)
                                            }

                                        }}>
                                            <b> {event.title}</b>
                                            <div>
                                                <span className="" style={{ fontWeight: "normal", fontSize: "1.1rem" }}>
                                                    <small>{moment(event.start).format(timeformatString)} - {moment(event.end).format(timeformatString)}</small>
                                                </span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>

                {/*  modal detailed snapshot of particular event*/}

                <Modal
                    show={showOptionsModal}
                    centered
                    className='myCalendarCloseButton'
                    onHide={() => { setShowOptionsModal(false); setEditData("") }}
                >

                    <Modal.Title className="text-center mt-2">
                        <i> {editData.title}  </i>
                        <br />
                        {(editData.event_type!=='group_session'&&editData.event_type!=='semi_private')&&
                            <span style={{ fontSize: "1.1rem" }} className="font-weight-bolder">
                                {generateTitleInfo(editData)}
                            </span>
                        }
                        <div>


                            <span className="" style={{ fontWeight: "normal", fontSize: "1.1rem" }}>
                                {moment(editData.start).format("MMMM DD")}
                                <br />
                                {moment(editData.start).format(timeformatString)} - {moment(editData.end).format(timeformatString)}
                            </span>
                        </div>
                    </Modal.Title>
                    <hr style={{ width: '100%', margin: '0px' }} />


                    <Modal.Body className="w-100" >
                        {editData.seriesStartDate &&
                            <small style={{ fontSize: "1rem" }}>
                                <div className="d-flex">
                                    <i className="fas fa-business-time mr-2 align-self-center"></i>
                                    <ReadableRepeat
                                        repeatType={editData.recurrence_type}
                                        eventType="event"
                                        startDate={editData.seriesStartDate}
                                        endDate={editData.seriesEndDate}
                                        repeatData={
                                            editData.recurrence_type === "day" 
                                            ? editData.repeat_frequency 
                                            : mapToDays(editData.week_days)
                                        }
                                        noEndDate={editData.no_end_date === "1"}
                                        weekRepeatFreq={editData?.repeat_frequency}
                                    /> </div>
                                <hr style={{ width: '100%', }} />

                            </small>
                        }

                        {editData.body &&
                            <div >
                                <i className="fas fa-align-left mr-2"></i> {editData.body}
                                <hr style={{ width: '100%', }} />
                            </div>}

                        {editData.clients?.length > 0 &&
                            <div className="mt-2">
                                <i className="fa fa-calendar mr-2 mt-3" aria-hidden="true"></i>
                                {determineClientNames()}
                            </div>
                        }

                        {editData.reminder_time !== 0 &&
                            <div>
                                <i className="fas fa-bell mr-2 mt-3"></i>
                                {editData.reminder_time} hours before event
                            </div>
                        }
                        <div>
                            <i className="fas fa-briefcase mr-2 mt-3"></i> 
                            {eventTypeText}
                        </div>
                        {(editData.event_type === 'group_session'&&Boolean(editData.consume_session_credit)&&isClient)&&
                            <div>
                                {totalAvailableSessionCredits>0&&
                                    <div>
                                        <i className="mr-2 mt-3 fas fa-coins"/> This class will use a session credit ({totalAvailableSessionCredits} remaining)
                                    </div>
                                }
                                {totalAvailableSessionCredits===0&&
                                    <div>
                                        <span className="text-danger">
                                            <i className="mr-2 mt-3 fas fa-coins"/> This class requires a session credit.
                                        </span>
                                        <br/>
                                        You can purchase more sessions <Link to="/financials_dashboard?tab=sessions">here</Link>
                                    </div>
                                }
                            </div>
                        }

                        <div className="mt-3 d-flex align-items-center">
                            <i className="fas fa-inbox mr-2 "></i>
                            <OverlayTrigger overlay={
                                <Tooltip>Add to google calendar</Tooltip>
                            }>
                                <a className="btn btn-sm mr-2 btn-outline-primary" href={handleCreateLink('google')} target="_blank">
                                    <i className="fab fa-google"> </i>
                                </a>
                            </OverlayTrigger>
                            <OverlayTrigger overlay={
                                <Tooltip>Download to calendar app</Tooltip>
                            }>
                                <a className="btn btn-sm mr-2 btn-outline-primary" href={handleCreateLink('ics')} target="_blank">
                                    <i className="fab fa-apple"></i>
                                    <span className="mx-2">/</span>
                                    <i className="fab fa-microsoft"></i>
                                </a>
                            </OverlayTrigger>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-between w-100">

                        {determineDeletePermissions(isClient, isTrainerOrGym, editData.status) && (editData.event_type!=='notes'||parseInt(editData.trainer_id)===parseInt(user.user_id_number)) ?
                            <div className="d-flex flex-column">
                                <ConfirmButton 
                                    onConfirm={() => {
                                        let isSeries = false;
                                        handleDeleteEvent(isSeries)
                                    }}
                                    cancelText="Cancel"
                                    initText={
                                        `Delete ${editData.seriesStartDate ? "Single" : ""} Event`
                                    }
                                    confirmText={isDeleting === "event" 
                                        ? <Spinner size="sm" animation="border"/> 
                                        : `Confirm Delete ${editData.seriesStartDate ? "Single" : ""} Event`
                                    }
                                    confirmVariant="danger"
                                    initVariant="outline-danger"
                                    disabled={isDeleting === "event"}
                                    size="sm"
                                />
                                {editData.seriesStartDate &&
                                    <ConfirmButton 
                                        className="mt-3"
                                        onConfirm={() => {
                                            let isSeries = true;
                                            handleDeleteEvent(isSeries)
                                        }}
                                        cancelText="Cancel"
                                        initText="Delete Series"
                                        confirmText={isDeleting === "series" ?
                                            <Spinner size="sm" animation="border"/> :
                                            "Confirm Delete Series"
                                        }
                                        confirmVariant="danger"
                                        initVariant="outline-danger"
                                        disabled={isDeleting === "series"}
                                        size="sm"
                                    />
                                }
                            </div> :
                            <div></div>}
                        <div className="flex-column d-flex">
                            {(isGroupSession&&isClient&&!isParticipant)&&
                                <>
                                    <Button 
                                        onClick={handleRegisterForGroupSession}
                                        disabled={
                                            registerStatus==='pending' 
                                            || !allowSignupCancel()
                                        }
                                        variant="outline-success"
                                        size="sm"
                                    >
                                        Register {registerStatus==='pending'&&<Spinner animation="border" size="sm"/>}
                                    </Button>
                                    {!allowSignupCancel()&&
                                        <div>
                                            You must register at least {editData.signup_cancel_buffer} hours before the start of the session
                                        </div>
                                    }
                                </>
                            }
                            {(isGroupSession&&isClient&&allowSignupCancel()&&!isParticipant)&&
                                <Form.Check
                                    onChange={e=>{
                                        setRecurringRegistration(
                                            e.target.checked
                                        )
                                    }}
                                    checked={recurringRegistration}
                                    id="recurring-registration-check"
                                    label="Make this a recurring registration"
                                />
                            }
                            {(isGroupSession&&isClient&&allowSignupCancel()&&!isParticipant&&recurringRegistration)&&
                                <small className="d-block text-danger">
                                    <i className="fa fa-exclamation-circle mr-1"/>
                                    Recurring registrations may not have availability on all days if someone has already registered for a specific day in the future. Please, always check your calendar to ensure you have a spot available. 
                                </small>
                            }
                            {(isGroupSession&&isClient&&allowSignupCancel()&&isParticipant&&editData.is_recurring_registration)&&
                                <Form.Check
                                    onChange={e=>{
                                        setRecurringRegistration(
                                            e.target.checked
                                        )
                                    }}
                                    checked={recurringRegistration}
                                    id="recurring-unregistration-check"
                                    label="Unregister from all sessions"
                                />
                            }
                             {(isGroupSession&&isClient&&isParticipant)&&
                                <>
                                    <Button 
                                        onClick={handleUnregisterForGroupSession}
                                        disabled={
                                            registerStatus==='pending' 
                                            || (editData.consume_session_credit && totalAvailableSessionCredits === 0 && editData.event_type!=='semi_private')
                                            || !allowSignupCancel()
                                        }
                                        variant="outline-danger"
                                        size="sm"
                                    >
                                        Unregister {registerStatus==='pending'&&<Spinner animation="border" size="sm"/>}
                                    </Button>
                                    {!allowSignupCancel()&&
                                        <div>
                                            You must unregister at least {editData.signup_cancel_buffer} hours before the start of the session
                                        </div>
                                    }
                                </>
                            }
                            {((!isGroupSession||!isClient)&&(editData.event_type!=='notes'||parseInt(editData.trainer_id)===parseInt(user.user_id_number)))&&
                                <>
                                    <Button size="sm" 
                                        onClick={() => {
                                            setShowOptionsModal(false)
                                            setEditSeries(false);
                                            setShowScheduleModal(true);
                                        }}
                                    > 
                                        {editData.status == "0" && isTrainerOrGym ? "View" : `Edit`} {editData.seriesStartDate && "Single"} Event
                                    </Button>


                                    {editData.seriesStartDate &&
                                        <Button
                                            className="mt-3"
                                            size="sm"
                                            onClick={() => {
                                                setEditSeries(true);
                                                setShowOptionsModal(false)
                                                setShowScheduleModal(true);
                                            }}> {editData.status == "0" && isTrainerOrGym ? "View" : "Edit"} Series </Button>
                                    }
                                </>
                            }
                        </div>
                    </Modal.Footer>
                </Modal>
                {!isClient&&<AvailabilityModal/>}
                <hr />
            </div>
        </div >

    )
}

export default EventCalendar